import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { installOsScaleCompensation } from "./lib/os-scale";

// Keep Windows OS DPI compensation current across monitor / scale changes.
installOsScaleCompensation();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
